export class CmiInteractionCorrectResponses{
	id
	interaction
	n
	pattern
}